import * as TerrassorConst from '../../../../terrassor_const.js'

import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE } from "../../../../interface.js";
import {getDateDetails} from "./date_details.js";



/* @ngInject */
export class DashboardController {
  /* @ngInject */
  constructor (ApiConst, ApiSimu, ApiExo, $scope, $filter, $q) {
    this.$scope = $scope
    this.$q = $q
    this.$filter = $filter
    this.ApiConst = ApiConst
    this.ApiSimu = ApiSimu
    this.ApiExo = ApiExo


    this.ignore = this.ignore.bind(this) 

    // trigger sur le changement de mouvement (ici code-mouvement : "M01", "M02", etc)
    this.watcher = this.$scope.$watch('DashboardController.resource', this.onResourceChange)

    // afficherTableauDeBord peut être appelé depuis un simple clic jQuery
    this.afficherTableauDeBord = this.afficherTableauDeBord.bind(this)
  }


  $onInit () {

    console.log('DashboardController : init')

    // on a bindé simplement le code du mouvement
    var resourceCode = this.resource

    this.dateDisplay = {}                   // elements de l'afficheur de la date

    //this.mode='MODE_MOUVEMENT'
    this.mode='MODE_CHANTIER'
    this.message = ' '
    this.volumes = {}
    this.couts = {}
    this.jours = {}

    this.nbJoursAtteints = 0;
    this.restartButtonsVisibles = false
    this.analyseButtonVisible = false
    this.bilanButtonVisible = false

    // this.installInhibe = this.parentSimulator.installationInhib // seulement dans showOtherButtons

  }

/*
* Pour les bindings inutiles sur <add-engin>
*/
  ignore(obj) { console.log('DashboardController::ignore', obj)  }

 /*
*/


afficherTableauDeBord() {
      var T_interface = get_Terrassor_INTERFACE()
      var datas = T_interface.donnerInfosTableauDeBord();

      this.setMode(datas) // mode chantier ou mode mouvement
      //  console.log('DashboardController::afficherTableauDeBord date', datas.chantier.date)

      this.data = datas

      if(this.mode == 'MODE_CHANTIER')
          this.formatInfosTempsReel(datas)
       else   
          this.onClickNavigation('mouvementSurCubature')

      // mouvments commencés deviennent read-only  
      this.setMouvementsCommencants()  
      // sauve le jour max en DB
      this.updateNbJoursAtteints()
      // montre les bouton "restart" / "correct" si on est arrivé à la fin
      this.showOtherButtons(T_interface.etude.jourFinReel)

      // c'est l'anim SVG qui dit si elle bloque sur les message ou pas
      this.parentSimulator.lock=datas.lock;
      this.parentSimulator.lockable=datas.lockable;
    }

/*
*/
updateNbJoursAtteints() {
  if(!(this.data && this.data.chantier))
    return 

  //var nbJoursAtteints = Math.max(this.parentSimulator.nbJoursAtteints, this.data.chantier.jour)
  var nbJoursAtteints = Math.max(this.parentSimulator.nbJoursAtteints, this.data.chantier.jour+1) // BC 2018/0829 : on ajoute 1 car svgObj (donnerInfosTempsreel) a passé "la veille au soir" du jour j courant
  this.parentSimulator.saveNbJoursAtteints(nbJoursAtteints)

}

/*
*/
setMouvementsCommencants() {

  if(!this.data.mouvementsCommencant || !this.data.mouvementsCommencant.length)
    return
  var arrayMouvements = this.data.mouvementsCommencant
  var parentSimulator = this.parentSimulator

  arrayMouvements.forEach(code => {
    return  this.ApiSimu.getMouvementByCode(code)
    .then(mvt => {
      mvt.simu_mouvements.commence = true
      // vérifier si le mouvement actuellement azffiché est celui ui démarre (pour maj des consignes)
      parentSimulator.checkCurrentMouvementStarted(code)
      console.log('Mouvement démarré', mvt)
      return this.ApiSimu.saveMouvement(mvt.simu_mouvements)
    })    
  })
}

/*
* boutons pour permettre la corrections des échelons et/ou le redémarrage de l'animation
*/
showOtherButtons(jourFin) {
  // if(this.parentSimulator.nbJoursAtteints >= (jourFin-1) ) { BC 2019/04 - les boutons apparaissent un jour trop tôt
  if(this.parentSimulator.nbJoursAtteints >= jourFin ) {
    this.restartButtonsVisibles = true
    this.analyseButtonVisible = true
    this.bilanButtonVisible = true

        // on peut "repasser" à l'installation si elle a été inhibée ...
    this.installInhibe = this.parentSimulator.installationInhib
        // sauf que ... on ne propose pas de "repasser" à l'installation si celle-ci a déjà été validée dans l'étude !!!!
    var analyse = get_Terrassor_INTERFACE().etude.analyse;
    if (typeof(analyse) != 'undefined') {
        if (typeof(analyse.passagesInstallation) != 'undefined') {
            if (analyse.passagesInstallation > 0) {
                this.installInhibe = false;
            }
        }
    }
  }
}


/*
* "restart" == mettre à 0 le jour de d&épart de l'anim
*/
restart() {
    this.parentSimulator.saveNbJoursAtteints(0)
    this.parentSimulator.lancerSVG(true)
    this.restartButtonsVisibles = false
    this.parentSimulator.setAnalyseContent(null)
    this.parentSimulator.bilanContent = "" // 2018/09/14

    // this.installInhibe = this.parentSimulator.installationInhib // pas sûr de la nécessité de cette action ... seulement dans showOtherButtons ?
}

/*
* "correct" == permettre l'edition des mouvements en les déclarant "non-commencés"
*/
correct() {
  this.parentSimulator.correct()//setAllMouvementNotStarted()
  this.restart() // ceci semble totalement inutile !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! BC 2019/05
}
correctEpure() {
  this.parentSimulator.correctEpure()
}


installFinInhib() {
  this.parentSimulator.installFinInhib()//setAllMouvementNotStarted()
}



/*
* "correct" == permettre l'edition des mouvements en les déclarant "non-commencés"
*/
reset() {
  if(confirm('Cette action va effacer toutes les sélections faites lors de cette planification.\nEtes vous sûr de vouloir réaliser cette opération ?'))
    this.parentSimulator.reset()
  
}
resetEpure() {
  if(confirm('Cette action va effacer toutes les sélections faites lors de cette planification.\nEtes vous sûr de vouloir réaliser cette opération ?'))
    this.parentSimulator.reset(TerrassorConst.ETAPE_SIMULATION)

}

/*
* Selon la nature des données, le TdB n'a pas la même interface (mode chantier / mode mouvement)
*/
setMode(data){

  this.mode = data.tempsReel ? 'MODE_CHANTIER' : 'MODE_MOUVEMENT'
  this.subMode = ''

  if(this.mode == 'MODE_MOUVEMENT') {
    this.setNavigation(data)
 }

}

/**
* Boutons de navigation en mopde mouvement
*/
setNavigation(data) {
  var navig = {'chantier':{},'mouvementSurCubature':{}, 'mouvement':{}, 'cubature':{}, 'echelon1':{}, 'echelon2':{}, 'echelon3':{}}

  if (typeof(data.mouvementSurCubature) != 'undefined') {
    navig.mouvementSurCubature.code = data.mouvementSurCubature.code
  }
  navig.mouvement.code = data.mouvement.code
  if (typeof(data.cubature) != 'undefined') {
      navig.cubature.code = data.cubature.code
  }
  navig.echelon1.exists = (typeof(data.echelon1) != 'undefined') ? true : false // ... mmmouais ...
  navig.echelon2.exists = (typeof(data.echelon2) != 'undefined') ? true : false
  navig.echelon3.exists = (typeof(data.echelon3) != 'undefined') ? true : false

  this.navigation = navig
}

/*
*/

onClickNavigation(typeData) {
    var data

    this.arrangeData() // certaines structures sont incomplètes et hétérogènes ...

    this.setSelected(typeData)

  switch(typeData) {
    case 'chantier' : 
      return this.formatInfosTempsReel(this.data)
      break;
        
    case 'mouvementSurCubature' : 
      data  = this.data.mouvementSurCubature
      return this.formatInfos(data, typeData)
      break;
    case 'mouvement' :
      data = this.data.mouvement
      return this.formatInfos(data, typeData)
      break;
    case 'cubature' :
      data = this.data.cubature
      return this.formatInfos(data, typeData)
      break;
    case 'echelon1' :
      data = this.data.echelon1
      return this.formatInfosEchelon(data, typeData)
      break;
    case 'echelon2' :
      data = this.data.echelon2
      return this.formatInfosEchelon(data, typeData)
      break;
    case 'echelon3' :
      data = this.data.echelon3
      return this.formatInfosEchelon(data, typeData)
      break;
  }

}


/*
* marqueur de sélection d'un element (cubature, echelon, chantier, ...)
*/
setSelected(selectedType) {
  for(var type in this.navigation)
    this.navigation[type].selected = false

  this.navigation[selectedType].selected=true;
  this.selectedType = selectedType

}

/*
* Copy de champs entre objets pour homogénéiser
* Not Used !!!
*/
arrangeData() {
    if(typeof(this.data.mouvementSurCubature) != 'undefined') {
        this.data.mouvementSurCubature.JJjour = this.data.mouvement.JJjour
        this.data.mouvementSurCubature.JJactifs = this.data.mouvement.JJactifs
        this.data.mouvementSurCubature.JJisactif = this.data.mouvement.JJisactif
    }
}

/* A la sélection d'un echelon, on affiche un bloc d'info par phase
*/
formatInfosEchelon(dataEchelon, typeData) {
  this.mode = 'MODE_MOUVEMENT'
  this.subMode = 'MODE_ECHELON'

  var infosPhasesEchelon = []
  var infosEchelon = {}

  dataEchelon.tabInfosPhases.forEach(ph => {
    var infoPhase = this.formatInfosPhase(ph)
    infosPhasesEchelon.push(infoPhase)
  })

  // "bind"  
  infosEchelon.rendement = this.formatNumber(dataEchelon.rendement)
  infosEchelon.coutActivite = this.formatNumber(dataEchelon.coutActivite)
  infosEchelon.coutInactivite = this.formatNumber(dataEchelon.coutInactivite)
  infosEchelon.infosPhasesEchelon = infosPhasesEchelon

  this.infosEchelon = infosEchelon

}

/**
*
*/

formatInfosPhase(phase) {

  var infoPhase = {}

  infoPhase.nom = phase.nomPhase  
  infoPhase.rendement = this.formatNumber(phase.rendement)
  infoPhase.coutActivite = this.formatNumber(phase.coutActivite)
  infoPhase.coutInactivite = this.formatNumber(phase.coutInactivite)

  return infoPhase
}

/*
*
*/
formatInfos(data, typeData) {
  this.mode = 'MODE_MOUVEMENT'
  this.subMode = ''
if (typeData == 'cubature') {
  this.subMode =  typeData
    }

if(!data)
  return;

var res = data

this.volumes.m3Traites = this.formatNumber(res.JJm3Traites)
this.volumes.m3TraitesDeblai = this.formatNumber(res.JJm3TraitesDeblai)
this.volumes.m3TraitesCompactage = this.formatNumber( res.JJm3TraitesCompactage)

var rendement = res.JJisactif ? res.rendement : 0
this.volumes.rendement = (rendement >= 0) ? this.formatNumber(rendement) : ''

this.couts.total = this.formatNumber(res.JJcout)
this.couts.parm3 = (res.JJm3Traites > 0) ? this.$filter('number')(res.JJcout/res.JJm3Traites, 2) : ''

this.jours.travailles = res.JJactifs
this.jours.chomes = res.JJjour - res.JJactifs

/*
this.Q = this.htmlLevelQSE(res.Q)
this.S = this.htmlLevelQSE(res.S)
this.E = this.htmlLevelQSE(res.E)
*/
// BC 09/2017
if(typeof(res.JJCO2) != 'undefined') {
    this.CO2 = this.formatNumber(Math.round(res.JJCO2/1000*100)/100); // tonnes eq. CO2
}
if(typeof(res.JJnbPersonnes) != 'undefined') {
    this.nbPersonnes = this.formatNumber(res.JJnbPersonnes);
}
else {
    if(typeof(res.nbPersonnes) != 'undefined') {
        this.nbPersonnes = this.formatNumber(res.nbPersonnes);
    }
}
if(typeof(res.JJnbEngins) != 'undefined') {
    this.nbEngins = this.formatNumber(res.JJnbEngins);
    if(typeof(res.JJnbEnginsReserves) != 'undefined') {
        var nbEnginsReels = this.$filter('number')(Math.round(res.JJnbEngins*10)/10);
        this.nbEngins = this.formatNumber(res.JJnbEnginsReserves) + ' ('+nbEnginsReels+')';
    }
}
else {
    if(typeof(res.nbEngins) != 'undefined') {
        this.nbEngins = this.formatNumber(res.nbEngins);
    }
}
// fin BC 09/2017

return this.$q.resolve(this.volumes)
}     


/*
* affichage 'confort' de type 1 234 567, vide si x undefined
*/
formatNumber(x) {

  if(typeof(x) == 'undefined')
    return ''

  return this.$filter('number')(Math.floor(0.5+x))

}



formatInfosTempsReel(datas) {
// this.mode = 'MODE_CHANTIER'
this.subMode = ''
this.subMode = 'chantier'
if(!datas)
  return;

this.message = datas.message
this.dateDisplay = getDateDetails(datas.chantier.dateBrute)

if(!datas.chantier.resultatsEnCours) {
    this.volumes.m3Traites = this.formatNumber(0)
    this.volumes.m3TraitesDeblai = this.formatNumber(0)
    this.volumes.m3TraitesCompactage = this.formatNumber(0)
    this.volumes.rendement = ''
    this.couts.total = this.formatNumber(0)
    this.couts.parm3 = ''
    this.jours.travailles = 0
    this.jours.chomes = 0
    this.CO2 = this.formatNumber(0); // tonnes eq. CO2
    this.nbPersonnes = this.formatNumber(0);
    this.nbEngins = this.formatNumber(0);
  return;
}
var res = datas.chantier.resultatsEnCours

// this.volumes.m3Traites = this.formatNumber(res.m3Traites)
this.volumes.m3Traites = this.formatNumber(res.m3Transportes) // BC 2018/09 - puisque on parle de m3 déplacé - on donne les m3 déplacés (pas de prise en compte du reglage)
this.volumes.m3TraitesDeblai = this.formatNumber(res.m3TraitesDeblai)
this.volumes.m3TraitesCompactage = this.formatNumber(res.m3TraitesCompactage)

//var rendement = (datas.chantier.jour) >0 ? (res.m3Traites / datas.chantier.jour * TerrassorConst.NB_HEURES_PAR_JOUR) : -1
var rendement = res.rendement

this.volumes.rendement = (rendement >= 0) ? (this.formatNumber(rendement)) : ''

this.couts.total = this.formatNumber(res.cout)

this.couts.parm3 = (res.m3Traites > 0) ? this.$filter('number')(res.coutMouvements/res.m3Traites, 2) : ''

this.jours.travailles = res.actifs
//this.jours.chomes = datas.chantier.jour - res.actifs
this.jours.chomes = datas.chantier.jour - res.actifs + 1 // au soir du j0 (début du chantier), il y a bien un jour d'écoulé : donc + 1

/*
this.Q = this.htmlLevelQSE(datas.chantier.Q)
this.S = this.htmlLevelQSE(datas.chantier.S)
this.E = this.htmlLevelQSE(datas.chantier.E)
*/

// BC 09/2017
this.CO2 = this.formatNumber(Math.round(res.CO2/1000*100)/100); // tonnes eq. CO2
this.nbPersonnes = this.formatNumber(res.nbPersonnes/*+datas.chantier.nbPersonnesInstallation*/);
this.nbEngins = this.formatNumber(res.nbEngins);


return this.$q.resolve(this.volumes)
// fin BC 09/2017

/*
this.$q.resolve(this.Q)
this.$q.resolve(this.S)
return this.$q.resolve(this.E)
*/
}     



/*
*
*/

htmlLevelQSE(level) {

    if(!level)
        level = 0;
    var tabLevels = []

    tabLevels[0] = ['n', 'n', 'n', 'n', 'n'] // pas de valeur définie
    tabLevels[1] = ['r', 'n', 'n', 'n', 'n'] // valeur 1 -> un symbole rouge
    tabLevels[2] = ['r', 'r', 'n', 'n', 'n'] // valeur 2 -> 2 symboles rouges
    tabLevels[3] = ['o', 'o', 'o', 'n', 'n'] // valeur 3 -> 3 symboles oranges
    tabLevels[4] = ['v', 'v', 'v', 'v', 'n'] // valeur 4 -> 4 symboles verts
    tabLevels[5] = ['v', 'v', 'v', 'v', 'v'] // valeur 4 -> 4 symboles verts


    var html = ''

    var currentLevel = tabLevels[level]  
    for(var i=0; i<currentLevel.length; i++)
      html += '<i class="fa fa-circle picto-level-' + currentLevel[i] + '">&nbsp;</i>'

    return html



  }


/*
* temporaire !!
*/

onClickAnalyse(appelIndirect) {
  var T_interface = get_Terrassor_INTERFACE()



  var data = T_interface.etude.analyse;
    data._Q = this.htmlLevelQSE(T_interface.etude.resultats.reel.Q)
    data._S = this.htmlLevelQSE(T_interface.etude.resultats.reel.S)
    data._E = this.htmlLevelQSE(T_interface.etude.resultats.reel.E)
    /*data.bilanResultats = T_interface.etude.resultats.reel
    data.bilanEtude = T_interface.etude
    data.bilanChantier = T_interface.etude.chantier*/

  this.parentSimulator.setAnalyseContent(data)


  if (typeof(appelIndirect) == 'undefined') {
      var context = new Object();
      context.panel = 'PEDAGO' // FINANCIER
        //this.parentSimulator.smoothScrollToPanel(context)
      this.parentSimulator.$timeout(() => {this.parentSimulator.smoothScrollToPanel(context)}, 250)
  }


}

onClickBilan(appelIndirect) {
    this.parentSimulator.bilanContent = "";
    this.parentSimulator.bilanContent = this.parentSimulator.lancerBILANFINANCIER()

    if (typeof(appelIndirect) == 'undefined') {
        var context = new Object();
        context.panel = 'FINANCIER'
        //this.parentSimulator.smoothScrollToPanel(context) // pour passer à l'identique du dessus bc 2018/09/28
      this.parentSimulator.$timeout(() => {this.parentSimulator.smoothScrollToPanel(context)}, 250)
    }
}

onClickPrint() {
    this.onClickAnalyse(1)
    this.onClickBilan(1)
    this.parentSimulator.$timeout(this.parentSimulator.archiverBILAN(), 500);
}

lockerUnlocker() {

      var T_interface = get_Terrassor_INTERFACE()
      T_interface.donnerInfosLock(this.parentSimulator.lock);
}
locker() {
    this.parentSimulator.lock=true;
    this.lockerUnlocker();
}
unlocker() {
    this.parentSimulator.lock=false;
    this.lockerUnlocker();
}



// ---------------------- en class
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/dashboard/dashboard.controller.js